// extracted by mini-css-extract-plugin
export var actionButton = "_9a-1";
export var actionButtons = "_9a-2";
export var actions = "_9a-0";
export var aiUnread = "_9a-10";
export var alignCenter = "_9a-h";
export var backWrapper = "_9a-3";
export var cellContainer = "_9a-4";
export var checkboxContainer = "_9a-5";
export var contentContainer = "_9a-6";
export var contentHeader = "_9a-8";
export var conversationsTableWrapper = "_9a-s";
export var draftReplyBadgeContainer = "_9a-m";
export var dropdownItem = "_9a-b";
export var dropdownItemsContainer = "_9a-a";
export var dropdownTitle = "_9a-c";
export var errorIcon = "_9a-7";
export var filter = "_9a-d";
export var gray = "_9a-i";
export var headerActionButtons = "_9a-e";
export var headerCheckboxContainer = "_9a-f";
export var icon = "_9a-j";
export var menuContainer = "_9a-k";
export var noMoreTicketsIcon = "_9a-12";
export var noMoreTicketsSubText = "_9a-13";
export var oneLine = "_9a-l";
export var optionsButton = "_9a-n";
export var plus = "_9a-o";
export var portalButtonsWrapper = "_9a-g";
export var red = "_9a-p";
export var scrolledTop = "_9a-9";
export var search = "_9a-q";
export var selectedConversationsCount = "_9a-r";
export var spinner = "_9a-t";
export var strong = "_9a-u";
export var summaryCell = "_9a-v";
export var tableContainer = "_9a-11";
export var tagContainer = "_9a-w";
export var threeDots = "_9a-x";
export var twoLines = "_9a-y";
export var unread = "_9a-z";